import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import CampaignListing from "../Components/CampaignListingComponent/CampaignListing";
import bellicon from "../assests/bellicon.svg";
import user from "../assests/user.svg";

import {
  Link,
  createSearchParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
import Context from "../context/Context";
import { campaignChips } from "../Contants/Contants";
import { isEmpty } from "lodash";

function CampaignsListingPage() {
  const [campaignData, setCampaignData] = useState();
  const [scrolling, setScrolling] = useState(false);
  const [newNotificationFound, setNewNotificationsFound] = useState(false);
  const sectionRefs = useRef({});
  const [selectedChip, setSelectedChip] = useState();
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, setPreviousLocation, searchParams } = useUserAuth();
  const { userIdToken, promptInstall, isPwa, isMobile } = useContext(Context);
  const token = userIdToken || currentUser?.accessToken;

  const getCampaignData = async () => {
    try {
      let config = {
        method: "get",
        url: `https://storage.googleapis.com/goviral_magazine_data/campaigns/data.json`,
      };
      let result = await axios(config);
      setCampaignData(result?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCampaignData();
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();
  }, []);
  const handleNotificationNavigate = () => {
    setPreviousLocation(window.location.pathname);
    navigate({
      pathname: `/notification`,
      search: `${searchParams ? createSearchParams(searchParams) : ""}`,
    });
  };
  const handleLogin = () => {
    setPreviousLocation(window.location.pathname);
    navigate(
      {
        pathname: `/signup`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      {
        state: {
          previousLocation: `/profile`,
        },
      }
    );
  };
  const newNotificationCheck = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_NOTIFICATION_STATUS_CHECKER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    }).then((response) => {
      setNewNotificationsFound(response?.data?.data?.newNotificationFound);
    });
  };
  const handleProfileNavigate = () => {
    setPreviousLocation(window.location.pathname);

    navigate(
      {
        pathname: `/profile`,
        search: `${searchParams ? createSearchParams(searchParams) : ""}`,
      },
      { state: { previousLocation: location?.pathname } }
    );
  };
  const handleScroll = () => {
    if (window.scrollY >= 20) {
      setScrolling(true);
    } else {
      setScrolling(false);
    }
  };
  window.addEventListener("scroll", handleScroll);
  const handleDownload = (evt) => {
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };

  const scrollToSection = (section) => {
    window.scrollTo({
      top: sectionRefs.current[section].offsetTop - 150,
      left: 0,
      behavior: "smooth",
    });
  };
  return (
    <div>
      <div className="max-w-[1440px] min-h-[100vh] mx-auto fonts-for-Sathosi-homepage bg-white">
        {isMobile ? (
          <div className=""></div>
        ) : (
          <div
            className={` w-[100%] py-[12px] px-[20px] flex items-center justify-between z-10 bg-white sticky top-0`}
          >
            <div className=" ">
              <Link
                to={
                  // isMobile
                  //   ? "https://mob.goviralit.com"
                  //   : "https://goviralit.com"
                  {
                    pathname: "/",
                    search: `${searchParams ? createSearchParams(searchParams) : ""}`,
                  }
                }
                className="text-center items-center flex"
              >
                <button className="   border-2 w-[40px] flex  text-center items-center h-[40px] border-[#D9D9D9] rounded-full">
                  <svg
                    className="ml-1 "
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M4.375 9.375H16.875C17.0408 9.375 17.1997 9.44085 17.3169 9.55806C17.4342 9.67527 17.5 9.83424 17.5 10C17.5 10.1658 17.4342 10.3247 17.3169 10.4419C17.1997 10.5592 17.0408 10.625 16.875 10.625H4.375C4.20924 10.625 4.05027 10.5592 3.93306 10.4419C3.81585 10.3247 3.75 10.1658 3.75 10C3.75 9.83424 3.81585 9.67527 3.93306 9.55806C4.05027 9.44085 4.20924 9.375 4.375 9.375Z"
                      fill="#161616"
                    />
                    <path
                      d="M4.63365 10.0001L9.8174 15.1826C9.93475 15.2999 10.0007 15.4591 10.0007 15.6251C10.0007 15.791 9.93475 15.9502 9.8174 16.0676C9.70004 16.1849 9.54087 16.2508 9.3749 16.2508C9.20893 16.2508 9.04975 16.1849 8.9324 16.0676L3.3074 10.4426C3.24919 10.3845 3.20301 10.3155 3.17151 10.2396C3.14 10.1637 3.12378 10.0823 3.12378 10.0001C3.12378 9.91785 3.14 9.83645 3.17151 9.76052C3.20301 9.68458 3.24919 9.61561 3.3074 9.55756L8.9324 3.93256C9.04975 3.8152 9.20893 3.74927 9.3749 3.74927C9.54087 3.74927 9.70004 3.8152 9.8174 3.93256C9.93475 4.04992 10.0007 4.20909 10.0007 4.37506C10.0007 4.54103 9.93475 4.7002 9.8174 4.81756L4.63365 10.0001Z"
                      fill="#161616"
                    />
                  </svg>
                </button>

                <p className="font-[700] text-[16px] hover:no-underline text-[#111] sm:text-[21px] ml-3 uppercase ">
                  home
                </p>
              </Link>
            </div>
            <>
              {currentUser ? (
                <div className="flex items-center gap-[13px]">
                  {!isPwa && (
                    <button
                      className="px-[16px] py-[12px] text-white bg-[#58B000] rounded-[12px] text-regular-medium"
                      onClick={() =>
                        navigate("/install", {
                          state: {
                            previousLocation: window.location.pathname,
                          },
                        })
                      }
                    >
                      Install Goviral App
                    </button>
                  )}

                  <div className="icon-bg relative">
                    <img
                      src={bellicon}
                      alt=""
                      className=" object-cover  overflow-hidden   cursor-pointer z-10"
                      onClick={handleNotificationNavigate}
                    />
                    {newNotificationFound && (
                      <div className="new-notification-indication absolute top-[2px] right-[2px]" />
                    )}
                  </div>

                  <img
                    src={currentUser?.photoURL ? currentUser?.photoURL : user}
                    alt=""
                    className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                    onClick={handleProfileNavigate}
                  />
                </div>
              ) : (
                <div className="flex gap-[16px]">
                  <img
                    src={user}
                    alt=""
                    className="h-[40px] w-[40px] object-cover rounded-full overflow-hidden cursor-pointer z-10"
                    onClick={handleLogin}
                  />
                </div>
              )}
            </>
          </div>
        )}

        <div
          className={`w-[100%] sticky  bg-[white] z-10 py-5  flex items-center text-black ${
            isMobile ? "top-0" : "top-14"
          }`}
        >
          <div className="ml-4  sm:ml-8 ">
            <button
              className="border-[1px] border-[#575757] py-[10px] px-[20px] uppercase sm:text-[16px] text-[12px] whitespace-nowrap"
              style={{ borderRadius: "0px 32px 32px 0px" }}
            >
              {" "}
              Campaigns
            </button>
          </div>
          <ul className="ml-4 sm:ml-16 w-fit  pr-[20px] font-headerLinks  grid-flow-col grid gap-[20px] overflow-x-auto [&::-webkit-scrollbar]:hidden">
            {campaignData?.campaigns?.map((item, index) => {
              let filterData = item?.sectionData;
              if (!isEmpty(filterData?.datas)) {
                return (
                  <li>
                    <button
                      className={`whitespace-nowrap uppercase ${
                        selectedChip === filterData?.secId &&
                        "bg-black text-[#F6F6F6]"
                      }  hover:bg-black hover:text-[#F6F6F6] text-[12px] sm:text-[16px] border-[1px]  py-2 px-5 rounded-[50px] `}
                      onClick={() => {
                        scrollToSection(filterData?.secId);
                        setSelectedChip(filterData?.secId);
                      }}
                    >
                      {" "}
                      {filterData?.name}{" "}
                    </button>
                  </li>
                );
              }
            })}
          </ul>
        </div>
        {campaignData?.campaigns?.map((item) => {
          let filterData = item?.sectionData;
          if (!isEmpty(filterData?.datas)) {
            return (
              <div
                ref={(ref) => {
                  sectionRefs.current[item?.sectionData?.secId] = ref;
                }}
              >
                <div className="mt-1 ">
                  <CampaignListing
                    data={item?.sectionData}
                    theme={campaignData?.themes}
                  />
                </div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}

export default CampaignsListingPage;
